import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=c2e58a60&scoped=true&"
import script from "./Title.vue?vue&type=script&lang=js&"
export * from "./Title.vue?vue&type=script&lang=js&"
import style0 from "./Title.vue?vue&type=style&index=0&id=c2e58a60&lang=scss&scoped=true&"
import style1 from "./Title.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e58a60",
  null
  
)

export default component.exports